import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {GrPagination} from '../../../../interfaces/general-interfaces';
import {NotificationsHttpService} from '../../../../services/http-services/notifications/notifications-http.service';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {TimeAgoPipe} from '../../../../pipes/time-ago/time-ago.pipe';
import {fadeInFadeOut} from '../../../../animations/fade-in-out-animation';
import {WebsocketsHelperService} from '../../../../services/helpers/websockets-helper.service';
import {AuthenticationHelperService} from '../../../../services/helpers/authentication-helper.service';
import {NotificationsModelTypeAdmin} from '../../../../enums/notification-enums';
import {Subscription} from 'rxjs';
import {NotificationsHelperService} from '../../../../services/helpers/notifications-helper.service';

@Component({
  selector: 'gr-notification-support-tab',
  standalone: true,
  templateUrl: './notification-support-tab.component.html',
  imports: [
    NgForOf,
    TimeAgoPipe,
    NgIf,
    NgClass
  ],
  animations: [fadeInFadeOut]
})
export class NotificationSupportTabComponent implements OnInit, OnDestroy {
  supportNotificationsPagination: GrPagination | undefined;
  supportNotifications: any[] = [];
  urlParams = {page: 1};
  imageForPreview = null;
  isRequestFinish = false;
  notificationsCount = 0;
  wsSupportNotificationsSubscription = new Subscription();
  @Output() supportNotificationsCount: EventEmitter<number> = new EventEmitter<number>();

  constructor(private notificationsHttpService: NotificationsHttpService,
              private websocketsHelperService: WebsocketsHelperService,
              private notificationsHelperService: NotificationsHelperService) {
  }

  ngOnInit(): void {
    this.supportNotificationsPagination = undefined;
    this.supportNotifications = [];
    this.getNotifications();
    this.wsSupportNotificationsSubscription = this.websocketsHelperService.supportNotificationReceivedSubject.subscribe((res: any) => {
      this.supportNotificationsCount.emit(this.notificationsCount + 1);
      this.supportNotifications.unshift(res.data);
    });
  }

  ngOnDestroy(): void {
    this.wsSupportNotificationsSubscription.unsubscribe();
  }

  getNotifications(): void {
    this.urlParams.page = (this.supportNotificationsPagination?.currentPage) ? this.supportNotificationsPagination.currentPage + 1 : 1;
    this.notificationsHttpService.getSupportNotifications(this.urlParams).then(res => {
      this.supportNotifications = [...this.supportNotifications, ...res.data];
      this.supportNotificationsPagination = res.pagination;
      this.notificationsCount = res.unreadCount;
      this.supportNotificationsCount.emit(this.notificationsCount);
      this.isRequestFinish = true;
    });
  }

  clickOnSupportNotification(notification: any): void {
    if (notification.read_at === null) {
      this.supportNotificationsCount.emit(--this.notificationsCount);
      this.notificationsHelperService.clickOnUnreadNotification();
      notification.read_at = Date.now();
      this.notificationsHttpService.postSupportReadNotification({notificationId: notification.id}).then(res => {});
    }
  }

  onScroll(event: any): void {
    const threshold = 100;
    const position = event.target.scrollTop + event.target.offsetHeight;
    const height = event.target.scrollHeight;

    if (position > height - threshold && (this.supportNotificationsPagination?.currentPage ?? 0) < (this.supportNotificationsPagination?.lastPage ?? 0) && this.isRequestFinish) {
      this.isRequestFinish = false;
      this.getNotifications();
    }
  }
}
